module.exports = __webpack_public_path__ + "static/academic-english-b5052f66a7b5fd520cb538737f03214f.jpg";